const initialState = {
    datas: [],
    data: false,
    dataSumberDatas: [],
    dataOrganisasis: [],
    dataOrganisasi: false,
    totResultOrganisasis: 0,
    totPageSumberDatas: 0,
    totResultSumberDatas: 0,
    totPageDatas: 0,
    totResultDatas: 0,
    isLoadingDatas: false,
    formSearchDatas: {
        SearchText: '',
        TagText: ''
    }
}

const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'DATAS':
            return { ...state, datas: action.payload }
        case 'DATA':
            return { ...state, data: action.payload }
        case 'DATA_SUMBER_DATAS':
            return { ...state, dataSumberDatas: action.payload }
        case 'DATA_ORGANISASIS':
            return { ...state, dataOrganisasis: action.payload }
        case 'DATA_ORGANISASI':
            return { ...state, dataOrganisasi: action.payload }
        case 'TOT_RESULT_ORGANISASIS':
            return { ...state, totResultOrganisasis: action.payload }
        case 'TOT_PAGE_SUMBER_DATAS':
            return { ...state, totPageSumberDatas: action.payload }
        case 'TOT_RESULT_SUMBER_DATAS':
            return { ...state, totResultSumberDatas: action.payload }
        case 'TOT_PAGE_DATAS':
            return { ...state, totPageDatas: action.payload }
        case 'TOT_RESULT_DATAS':
            return { ...state, totResultDatas: action.payload }
        case 'IS_LOADING_DATAS':
            return { ...state, isLoadingDatas: action.payload }
        case 'FORM_SEARCH_DATAS':
            return {
                ...state,
                formSearchDatas: {
                    ...state.formSearchDatas,
                    [action.formType]: action.formValue
                }
            }
        case 'RESET_FORM_SEARCH_DATAS':
            return { ...state, formSearchDatas: initialState.formSearchDatas }
        default:
            return state
    }
}

export default dataReducer;